/* eslint-disable camelcase */
import Api from '../api';

const createTrack = (event_name: string, event_data: object = {}) => {
  Api.post('/tracks', { event: { name: event_name, data: event_data } });
};

export default createTrack;
